import React, { Component } from 'react';
import '../../css/pages/agents.css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Nav from 'react-bootstrap/esm/Nav';
import { toast } from 'react-toastify';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchAgent, fetchAgentStats, updateAgent } from '../actions/account';
import Pagination from '../components/Pagination';
import { fetchLoans } from '../actions/p2p';

class ViewAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loans: [],
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    this.fetchAgentDetails(match.params.id);

    fetchAgentStats(match.params.id)
      .then(({ data }) => {
        const reports = [];
        const stats = data.stats.reduce((acc, curr) => {
          acc[curr.status.status] = curr.count;
          return acc;
        }, {});
        reports.push(
          {
            title: 'Number of Loans Disbursed',
            description: `${(Number(stats.RUNNING || 0) + Number(stats.SETTLED || 0) + Number(stats['PAST DUE'] || 0)).toLocaleString()}`,
          },
          {
            title: 'Total Loans Disbursed',
            description: `₦ ${Number(data?.summary?.total_principal || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          },
          {
            title: 'Total Earned',
            description: `₦ ${Number(data?.summary?.total_income || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          },
          {
            title: 'Outstanding Principal',
            description: `₦ ${Number(data?.summary?.outstanding_principal || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          },
          {
            title: 'Outstanding Interest',
            description: `₦ ${Number(data?.summary?.outstanding_earning || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          },
          {
            title: 'Number of running loans',
            description: `${Number(stats.RUNNING || 0).toLocaleString()}`,
          },
          {
            title: 'Number of past due loans',
            description: `${Number(stats['PAST DUE'] || 0).toLocaleString()}`,
          },
          {
            title: 'Percentage of passed due loans',
            description: `${((Number(stats['PAST DUE'] || 0) / (Number(stats.RUNNING || 0) + Number(stats.SETTLED || 0) + Number(stats['PAST DUE'] || 0))) * 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}%`,
          },
        );
        this.setState({ reports });
      });
  }

  fetchAgentDetails = (id) => {
    fetchAgent(id)
      .then(({ data: agent }) => {
        const details = [];
        const preference = [];
        const detail = agent;
        details.push(
          { title: 'Name', description: `${agent.first_name || ''} ${agent.last_name || ''}` },
          { title: 'Phone Number', description: `${agent.phone_number}` },
          { title: 'Email', description: `${agent.email}` },
          { title: 'Status', description: `${agent.status}` },
        );
        preference.push(
          { title: 'Risk Appetite', description: `${agent?.lender_profile?.risk_appetite || '-'}` },
          { title: 'Minimum Amount', description: `₦ ${Number(agent?.lender_profile?.min_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`, },
          { title: 'Maximum Amount', description: `₦ ${Number(agent?.lender_profile?.max_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`, },
          { title: 'Maximum Number of Loans', description: `${Number(agent?.lender_profile?.max_loan_count || 0).toLocaleString()}` },
          { title: 'Minimum Tenor', description: `${agent?.lender_profile?.min_tenor_value || '-'} ${agent?.lender_profile?.min_tenor_type || '-'}` },
          { title: 'Maximum Tenor', description: `${agent?.lender_profile?.max_tenor_value || '-'} ${agent?.lender_profile?.max_tenor_type || '-'}` },
          { title: 'Minimum Credit Score', description: `${agent?.lender_profile?.minimium_credit_score || '-'}` },
        );
        this.setState({ details, detail, preference });
      });
  }

  handlePageChange = (data) => {
    const { limit } = this.state;
    const { match } = this.props;
    fetchLoans(data.currentPage, '', 'created_on', 'DESC', limit, match.params.id)
      .then(({ data: { loans, page_info } }) => this.setState({
        loans,
        current_page: page_info.page,
        total: page_info.total,
      }));
  };

  handleUpdateAgent = (data) => {
    this.setState({ processing: true }, async () => {
      try {
        const response = await updateAgent(data);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message, {
          onClose: () => {
            this.setState({ processing: false });
          },
        });
        this.fetchAgentDetails(data.id);
      } catch (error) {
        this.setState({ processing: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ processing: false });
      }
    });
  }

  render() {
    const {
      loans, total, current_page, limit, reports = [], details = [], preference = [], detail = {}, processing,
    } = this.state;
    const { history } = this.props;
    return (
      <>
        <SideNav page="agents" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="agents" />
            <section className="body-main__content">
              <div className="agents">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Agent</h3>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="">
                      <div className="filter-and-search d-flex justify-content-end">
                        <div className="button-box me-lg-3">
                          <Link type="submit" onClick={() => history.push(`/update-agent/${detail?.id}`)} className="btn btn-outline-primary">
                            Edit Agent
                          </Link>
                        </div>
                        <div className="button-box">
                          <Link
                            className="btn btn-danger"
                            disabled={!!processing}
                            onClick={() => this.handleUpdateAgent({ id: detail?.id, status: detail?.status === 'active' ? 'deactivated' : 'active' })}>
                            {processing ? '...' : `${detail?.status === 'active' ? 'Disable agent' : 'Enable agent'}`}
                          </Link>
                        </div>
                      </div>
                      {!!details.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {details.map((detail) => (
                              <div className="col-12 col-md-3" key={detail.title}>
                                <div>
                                  <p>{detail.title}</p>
                                  <h6 className="fw-bold">
                                    {detail.description}
                                  </h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!preference.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {preference.map((pref) => (
                              <div className="col-12 col-md-3" key={pref.title}>
                                <div>
                                  <p>{pref.title}</p>
                                  <h6 className="fw-bold">
                                    {pref.description}
                                  </h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!reports.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {reports.map((report) => (
                              <div className="col-12 col-md-3" key={report.id}>
                                <div>
                                  <p>{report.title}</p>
                                  <h6 className="fw-bold">
                                    {report.description}
                                  </h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col">
                          <div className="card default-card settings">
                            <Nav
                              className="nav nav-tabs"
                              as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link active" eventKey="profile">
                                  Loans
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            <div className="tab-content">
                              <div className="tab-pane fade show active">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead className="bg-secondary">
                                      <tr>
                                        <th className="name text-white px-5">Name</th>
                                        <th className="phone_number text-white">Phone Number</th>
                                        <th className="tenor text-white">Tenor</th>
                                        <th className="loan_amount text-white">Loan Amount</th>
                                        <th className="interest text-white">Interest</th>
                                        <th className="status text-white">Status</th>
                                        <th className="date-time text-white">Date Disbursed</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loans.map((loan) => (
                                        <tr key={loan.id} onClick={() => history.push(`/loans/${loan.id}`)} role="button">
                                          <td className="name px-5">
                                            {loan?.user?.first_name}
                                            {' '}
                                            {loan?.user?.last_name}
                                          </td>
                                          <td className="phone_number">
                                            {loan?.user?.phone_number}
                                          </td>
                                          <td className="tenor">
                                            {loan?.tenor}
                                            {' '}
                                            {loan?.tenor_period}
                                          </td>
                                          <td className="loan_amount">{Number(loan.loan_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                          <td className="interest">
                                            {loan.interest_rate}
                                            %
                                          </td>
                                          <td className="status">{loan.status?.status}</td>
                                          <td className="date-time">
                                            <span className="date">{loan.disbursed_on ? moment(loan.disbursed_on).format('MMM DD, YYYY, h:mm:ss a') : '---'}</span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Pagination
                        totalRecords={total}
                        pageLimit={limit}
                        pageNeighbours={1}
                        onPageChanged={this.handlePageChange}
                        initialPage={current_page} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default ViewAgent;
